import React, { useState } from 'react';
import { supabase } from '../services/supabase';
import '../styles/RegisterPage.css';

const EMPTY_FORM = {
  email: '',
  password: '',
  confirmPassword: '',
  voen: '',
  license_number: '',
  owner_name: '',
  owner_phone: '',
  cafe_name: '',
  business_type: 'cafe',
  cuisine_type: '',
  address: '',
  city: 'Bakı',
  phone: '',
  capacity: '',
  company_name: '',
  legal_name: '',
  owner_position: '',
  owner_id_number: '',
};

const CITIES = [
  'Bakı', 'Gəncə', 'Sumqayıt', 'Mingəçevir', 'Naxçıvan', 'Lənkəran', 'Şirvan', 'Şəki', 'Yevlax', 'Xankəndi',
  'Abşeron', 'Ağcabədi', 'Ağdam', 'Ağdaş', 'Ağstafa', 'Ağsu', 'Astara', 'Balakən', 'Bərdə', 'Beyləqan',
  'Biləsuvar', 'Cəbrayıl', 'Cəlilabad', 'Daşkəsən', 'Füzuli', 'Gədəbəy', 'Goranboy', 'Göyçay', 'Göygöl',
  'Hacıqabul', 'Hadrut', 'İmişli', 'İsmayıllı', 'Kəlbəcər', 'Kürdəmir', 'Laçın', 'Lerik', 'Masallı', 'Neftçala',
  'Oğuz', 'Qax', 'Qazax', 'Qəbələ', 'Qobustan', 'Quba', 'Qubadlı', 'Qusar', 'Saatlı', 'Sabirabad',
  'Salyan', 'Samux', 'Siyəzən', 'Şamaxı', 'Şəmkir', 'Şuşa', 'Tartar', 'Tovuz', 'Ucar', 'Xaçmaz',
  'Xızı', 'Xocavənd', 'Yardımlı', 'Zaqatala', 'Zəngilan', 'Zərdab',
  'Babək', 'Culfa', 'Kəngərli', 'Ordubad', 'Sədərək', 'Şahbuz', 'Şərur',
];

function TermsText() {
  const p = { fontSize: 13, lineHeight: 1.75, color: '#374151', marginBottom: 10 };
  const h = { fontSize: 13, fontWeight: 700, color: '#1a1a2e', marginTop: 18, marginBottom: 4 };
  return (
    <div>
      <p style={{ ...p, fontWeight: 700, textAlign: 'center', fontSize: 14, marginBottom: 16 }}>
        İSTİFADƏ ŞƏRTLƏRİ VƏ GİZLİLİK SİYASƏTİ
      </p>
      <p style={h}>1. Platformanın Məqsədi</p>
      <p style={p}>Cafegoo biznes paneli ("Platforma") iaşə müəssisələrinə rezervasiya idarəetməsi, menyu, kampaniya və analitika xidmətləri göstərir. Platforma "Eintree Solutions" MMC tərəfindən idarə edilir.</p>
      <p style={h}>2. Hesab Məsuliyyəti</p>
      <p style={p}>Qeydiyyat zamanı daxil etdiyiniz məlumatların doğruluğuna görə siz məsuliyyət daşıyırsınız. Giriş məlumatlarınızı üçüncü şəxslərlə paylaşmamağınız tövsiyə edilir.</p>
      <p style={h}>3. Xidmət Şərtləri</p>
      <p style={p}>Platforma xidmətlərindən yalnız qanuni məqsədlər üçün istifadə edilə bilər. Sistemin işinə mane olan, digər istifadəçilərə zərər verən və ya platformanın reputasiyasını zədələyən hər hansı fəaliyyət qadağandır.</p>
      <p style={h}>4. Rezervasiya və Müştəri Məlumatları</p>
      <p style={p}>Panel vasitəsilə əldə etdiyiniz müştəri məlumatları (ad, telefon, rezervasiya tarixi) yalnız xidmət göstərmək məqsədilə istifadə edilə bilər. Bu məlumatların üçüncü şəxslərə ötürülməsi qadağandır.</p>
      <p style={h}>5. Abunəlik Qiymətlərinin Məxfiliyi</p>
      <p style={p}>Cafegoo tərəfindən sizə təklif edilən abunəlik haqqı, endirim şərtləri və xüsusi razılaşma məlumatları kommersiya sirri sayılır. Bu məlumatları rəqib platformalara, üçüncü şəxslərə və ya ictimaiyyətə açıqlamaq qadağandır. Pozuntu aşkar edildiyi halda Platforma əməkdaşlığa birtərəfli xitam vermək hüququna malikdir.</p>
      <p style={h}>6. Platformanın Hüquqları</p>
      <p style={p}>Platforma xidmət şərtlərini 30 gün öncədən bildirməklə yeniləmək hüququna malikdir. Sistem nasazlığı halında Platforma 24 saat ərzində bərpa təmin edir.</p>
      <p style={h}>7. Gizlilik və Məlumatların Qorunması</p>
      <p style={p}>Biznes məlumatlarınız Supabase infrastrukturunda şifrələnmiş şəkildə saxlanılır. Hesabınız silindiyi tarixdən 30 gün sonra bütün məlumatlar tamamilə məhv edilir. Platforma məlumatlarınızı heç bir üçüncü tərəflə reklam məqsədilə paylaşmır.</p>
      <p style={h}>8. Canlı Masa Məlumatlarının Yenilənməsi</p>
      <p style={p}>Platformada göstərilən canlı masa dolulluğu məlumatlarının daim aktual saxlanması müəssisənin öhdəliyindədir. Yanlış və ya köhnəlmiş məlumatlar səbəbindən müştərinin yaşadığı hər hansı narahatlıq, itki və ya şikayətə görə Platforma heç bir məsuliyyət daşımır.</p>
      <p style={h}>9. Uyğun Hüquq</p>
      <p style={p}>Bu şərtlər Azərbaycan Respublikasının qanunvericiliyinə uyğun olaraq tənzimlənir. Mübahisələr Bakı şəhərinin müvafiq məhkəmələrində həll edilir.</p>
    </div>
  );
}

const RegisterPage = () => {
  const [loading, setLoading]             = useState(false);
  const [error, setError]                 = useState('');
  const [isChain, setIsChain]             = useState(null);
  const [currentStep, setCurrentStep]     = useState(0);
  const [formData, setFormData]           = useState(EMPTY_FORM);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [submitted, setSubmitted]         = useState(false);
  const [contractNumber] = useState(() => {
    const ts   = Date.now().toString(36).toUpperCase();
    const rand = Math.random().toString(36).slice(2, 5).toUpperCase();
    return `CF-${ts}-${rand}`;
  });

  // single: kafe(1) + sahibi+email(2) + şərtlər(3)
  // chain:  hüquqi(1) + sahibi(2) + email(3) + şərtlər(4)
  const totalSteps = isChain ? 4 : 3;

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const chooseChain  = (value) => { setIsChain(value); setCurrentStep(1); setError(''); };

  const validators = {
    singleStep1: () => {
      if (!formData.cafe_name || !formData.address || !formData.phone) { setError('Ad, ünvan və telefon mütləqdir'); return false; }
      return true;
    },
    singleStep2: () => {
      if (!formData.owner_name || !formData.voen || !formData.email) { setError('Ad, VÖEN və email mütləqdir'); return false; }
      if (formData.voen.length !== 10) { setError('VÖEN 10 rəqəmli olmalıdır'); return false; }
      if (!formData.email.includes('@')) { setError('Düzgün email daxil edin'); return false; }
      if (!formData.password || formData.password.length < 6) { setError('Şifrə ən azı 6 simvol olmalıdır'); return false; }
      if (formData.password !== formData.confirmPassword) { setError('Şifrələr uyğun gəlmir'); return false; }
      return true;
    },
    chainStep1: () => {
      if (!formData.company_name || !formData.legal_name || !formData.voen) { setError('Şirkət adı, hüquqi adı və VÖEN mütləqdir'); return false; }
      if (formData.voen.length !== 10) { setError('VÖEN 10 rəqəmli olmalıdır'); return false; }
      return true;
    },
    chainStep2: () => {
      if (!formData.owner_name || !formData.owner_position || !formData.owner_phone) { setError('Ad, vəzifə və telefon mütləqdir'); return false; }
      return true;
    },
    chainStep3: () => {
      if (!formData.email || !formData.email.includes('@')) { setError('Düzgün email daxil edin'); return false; }
      if (!formData.password || formData.password.length < 6) { setError('Şifrə ən azı 6 simvol olmalıdır'); return false; }
      if (formData.password !== formData.confirmPassword) { setError('Şifrələr uyğun gəlmir'); return false; }
      return true;
    },
    terms: () => {
      if (!termsAccepted) { setError('İstifadə şərtlərini oxuyub qəbul etməlisiniz'); return false; }
      return true;
    },
  };

  const handleNext = () => {
    setError('');
    let valid = false;
    if (!isChain) {
      if (currentStep === 1) valid = validators.singleStep1();
      else if (currentStep === 2) valid = validators.singleStep2();
    } else {
      if (currentStep === 1) valid = validators.chainStep1();
      else if (currentStep === 2) valid = validators.chainStep2();
      else if (currentStep === 3) valid = validators.chainStep3();
    }
    if (valid) setCurrentStep(s => s + 1);
  };

  const handleBack = () => {
    setError('');
    if (currentStep === 1) { setCurrentStep(0); setIsChain(null); }
    else setCurrentStep(s => s - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!validators.terms()) return;
    setLoading(true);

    try {
      // 1. Mövcud müraciəti yoxla
      const { data: checkRes } = await supabase.rpc('check_existing_application', {
        p_email: formData.email, p_voen: formData.voen,
      });
      const existingApp = checkRes?.exists ? { id: checkRes.id, status: checkRes.status } : null;

      if (existingApp && existingApp.status === 'pending') {
        const confirmed = window.confirm(
          '⚠️ Bu email və ya VÖEN ilə artıq gözləyən müraciət mövcuddur.\n\nKöhnə müraciəti silib yenisini göndərmək istəyirsiniz?'
        );
        if (!confirmed) { setLoading(false); return; }
      }

      if (existingApp && existingApp.status === 'approved') {
        setError('Bu email artıq təsdiqlənmiş hesaba aiddir. Giriş səhifəsindən daxil olun.');
        setLoading(false);
        return;
      }

      // 2. Köhnə müraciəti sil
      if (existingApp) {
        await supabase.rpc('delete_own_pending_application', { p_id: existingApp.id, p_voen: formData.voen });
      }

      // 3. Şifrə verilibsə auth user yarat
      if (formData.password) {
        const { error: authError } = await supabase.auth.signUp({
          email: formData.email,
          password: formData.password,
          options: { data: { full_name: formData.owner_name, account_type: 'business_manager', user_type: 'business_manager' } },
        });
        if (authError && !authError.message?.toLowerCase().includes('already registered')) {
          throw new Error(authError.message);
        }
        // Email təsdiqini avtomatik keç (biznes hesabı admin tərəfindən yaradılır)
        await supabase.rpc('confirm_business_auth_user', { p_email: formData.email });
        await supabase.auth.signOut();
      }

      // 4. Müraciəti yaz
      const record = {
        user_id: null,
        email: formData.email,
        voen: formData.voen,
        license_number: formData.license_number || null,
        representative_name: formData.owner_name,
        representative_email: formData.email,
        representative_phone: formData.owner_phone || null,
        is_chain: isChain,
        contract_accepted: true,
        contract_accepted_at: new Date().toISOString(),
        contract_number: contractNumber,
        status: 'pending',
      };

      if (!isChain) {
        Object.assign(record, {
          company_name: formData.cafe_name,
          legal_name: formData.cafe_name,
          business_type: formData.business_type,
          cuisine_type: formData.cuisine_type || null,
          address: formData.address,
          city: formData.city,
          phone: formData.phone,
          capacity: formData.capacity ? parseInt(formData.capacity) : null,
          representative_position: 'Sahibi',
        });
      } else {
        Object.assign(record, {
          company_name: formData.company_name,
          legal_name: formData.legal_name,
          phone: formData.owner_phone || '',
          address: formData.address || '',
          city: '',
          business_type: 'chain',
          representative_position: formData.owner_position,
          representative_id_number: formData.owner_id_number || null,
        });
      }

      const { error: appError } = await supabase.from('business_applications').insert([record]);
      if (appError) throw appError;

      setSubmitted(true);
    } catch (err) {
      console.error('Registration error:', err);
      setError('Xəta baş verdi: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const stepLabels = !isChain
    ? ['Kafe', 'Sahibi', 'Şərtlər']
    : ['Hüquqi', 'Sahibi', 'Email', 'Şərtlər'];

  const isTermsStep = currentStep === totalSteps;

  if (submitted) return (
    <div className="register-container">
      <div className="register-box" style={{ maxWidth: 480, textAlign: 'center' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>✅</div>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: '#1a1a2e', marginBottom: 8 }}>
          Müraciət Göndərildi!
        </h2>
        <p style={{ color: '#666', fontSize: 14, lineHeight: 1.7, marginBottom: 24 }}>
          Müraciətiniz uğurla qəbul edildi.<br />
          Yoxlandıqdan sonra <strong>{formData.email}</strong> ünvanına giriş məlumatları göndəriləcək.<br />
          Müqavilənin islaq imzalı nüsxəsi üçün komandamız sizinlə əlaqə saxlayacaq.
        </p>
        <div style={{
          background: '#FFF7E6', border: '1px solid #fde68a',
          borderRadius: 12, padding: '14px 18px', marginBottom: 28,
          fontSize: 13, color: '#92400e', textAlign: 'left',
        }}>
          <strong>Müqavilə №:</strong> {contractNumber}<br />
          <strong>Status:</strong> Gözləmədə — adətən 1-2 iş günü ərzində cavab verilir
        </div>
        <div style={{ marginTop: 16 }}>
          <a href="/application-status" style={{ fontSize: 13, color: '#888' }}>
            Müraciətin statusunu yoxla
          </a>
        </div>
      </div>
    </div>
  );

  return (
    <div className="register-container">
      <div className="register-box" style={isTermsStep ? { maxWidth: 720 } : {}}>
        <div className="register-header">
          <h1>☕ Cafegoo</h1>
          <p>Biznes Qeydiyyatı</p>
        </div>

        {/* ── Step 0: Branch selector ─────────────────────────────────────── */}
        {currentStep === 0 && (
          <div className="form-step" style={{ textAlign: 'center' }}>
            <h3 style={{ marginBottom: 8 }}>Kafenizin filialları varmı?</h3>
            <p style={{ fontSize: 13, color: '#888', marginBottom: 28 }}>Qeydiyyat növünü seçin</p>
            <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button type="button" onClick={() => chooseChain(false)} style={{
                flex: 1, minWidth: 140, maxWidth: 200, padding: '24px 16px', borderRadius: 14,
                border: '2px solid #E8940A', background: '#FFF7E6', cursor: 'pointer', textAlign: 'center',
              }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>☕</div>
                <div style={{ fontWeight: 700, fontSize: 15, color: '#1a1a1a', marginBottom: 4 }}>Tək Kafe</div>
                <div style={{ fontSize: 12, color: '#888', lineHeight: 1.5 }}>Bir lokasiyon — tam kafe qeydiyyatı</div>
              </button>
              <button type="button" onClick={() => chooseChain(true)} style={{
                flex: 1, minWidth: 140, maxWidth: 200, padding: '24px 16px', borderRadius: 14,
                border: '2px solid #ddd', background: '#fafafa', cursor: 'pointer', textAlign: 'center',
              }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>🏢</div>
                <div style={{ fontWeight: 700, fontSize: 15, color: '#1a1a1a', marginBottom: 4 }}>Filial Şəbəkəsi</div>
                <div style={{ fontSize: 12, color: '#888', lineHeight: 1.5 }}>Bir neçə lokasiyon — hüquqi şəxs qeydiyyatı</div>
              </button>
            </div>
            <div className="register-footer" style={{ marginTop: 28 }}>
              <p>Artıq hesabınız var? <a href="/login">Daxil olun</a></p>
            </div>
          </div>
        )}

        {/* ── Steps 1+ ────────────────────────────────────────────────────── */}
        {currentStep >= 1 && (
          <>
            <div className="progress-steps">
              {stepLabels.map((label, i) => (
                <React.Fragment key={label}>
                  <div className={`step ${currentStep >= i + 1 ? 'active' : ''}`}>
                    <div className="step-number">{i + 1}</div>
                    <span>{label}</span>
                  </div>
                  {i < stepLabels.length - 1 && (
                    <div className={`step-line ${currentStep >= i + 2 ? 'active' : ''}`} />
                  )}
                </React.Fragment>
              ))}
            </div>

            <form onSubmit={handleSubmit} className="register-form">

              {/* ── SINGLE: Step 1 — Cafe Details ─────────────────────────── */}
              {!isChain && currentStep === 1 && (
                <div className="form-step">
                  <h3>Kafe Məlumatları</h3>
                  <div className="form-group">
                    <label>Kafenin Adı *</label>
                    <input type="text" name="cafe_name" value={formData.cafe_name} onChange={handleChange} placeholder="Məs. Blue Cup Café" />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Biznes Növü *</label>
                      <select name="business_type" value={formData.business_type} onChange={handleChange}>
                        <option value="cafe">Kafe</option>
                        <option value="restaurant">Restoran</option>
                        <option value="bar">Bar</option>
                        <option value="fast_food">Fast Food</option>
                        <option value="club">Klub</option>
                        <option value="hookah">Qəlyan</option>
                        <option value="teahouse">Çayxana</option>
                        <option value="hotel">Otel</option>
                        <option value="bakery">Çörəkxana / Patisserie</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Mətbəx Növü</label>
                      <input type="text" name="cuisine_type" value={formData.cuisine_type} onChange={handleChange} placeholder="Azərbaycan, İtalyan..." />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Ünvan *</label>
                    <input type="text" name="address" value={formData.address} onChange={handleChange} placeholder="28 May küç. 5" />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Şəhər *</label>
                      <select name="city" value={formData.city} onChange={handleChange}>
                        {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Telefon *</label>
                      <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="+994501234567" />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Tutum (Yer sayı)</label>
                      <input type="number" name="capacity" value={formData.capacity} onChange={handleChange} placeholder="50" min="1" />
                    </div>
                  </div>
                </div>
              )}

              {/* ── SINGLE: Step 2 — Owner + Email + Şifrə ───────────────── */}
              {!isChain && currentStep === 2 && (
                <div className="form-step">
                  <h3>Sahibi və Giriş Məlumatları</h3>
                  <div className="form-group">
                    <label>Sahibinin Adı Soyadı *</label>
                    <input type="text" name="owner_name" value={formData.owner_name} onChange={handleChange} placeholder="Əli Məmmədov" />
                  </div>
                  <div className="form-group">
                    <label>Sahibinin Telefonu</label>
                    <input type="tel" name="owner_phone" value={formData.owner_phone} onChange={handleChange} placeholder="+994501234567" />
                  </div>
                  <div className="form-group">
                    <label>VÖEN (10 rəqəm) *</label>
                    <input type="text" name="voen" value={formData.voen} onChange={handleChange} placeholder="1234567890" maxLength="10" />
                    <small>Vergi Ödəyicisinin Eyniləşdirmə Nömrəsi</small>
                  </div>
                  <div className="divider" />
                  <div className="form-group">
                    <label>Email *</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="admin@kafem.az" />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Şifrə * <small>(min. 6 simvol)</small></label>
                      <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="••••••••" />
                    </div>
                    <div className="form-group">
                      <label>Şifrəni Təsdiqlə *</label>
                      <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="••••••••" />
                    </div>
                  </div>
                </div>
              )}

              {/* ── CHAIN: Step 1 — Legal Info ────────────────────────────── */}
              {isChain && currentStep === 1 && (
                <div className="form-step">
                  <h3>Hüquqi Məlumatlar</h3>
                  <div className="form-group">
                    <label>Şirkətin Adı * <small>(brend adı)</small></label>
                    <input type="text" name="company_name" value={formData.company_name} onChange={handleChange} placeholder="Coffeemania" />
                  </div>
                  <div className="form-group">
                    <label>Hüquqi Adı * <small>(rəsmi qeydiyyat adı)</small></label>
                    <input type="text" name="legal_name" value={formData.legal_name} onChange={handleChange} placeholder="Coffeemania MMC" />
                  </div>
                  <div className="form-group">
                    <label>VÖEN (10 rəqəm) *</label>
                    <input type="text" name="voen" value={formData.voen} onChange={handleChange} placeholder="1234567890" maxLength="10" />
                    <small>Vergi Ödəyicisinin Eyniləşdirmə Nömrəsi</small>
                  </div>
                </div>
              )}

              {/* ── CHAIN: Step 2 — Owner Identity ───────────────────────── */}
              {isChain && currentStep === 2 && (
                <div className="form-step">
                  <h3>Sahibin Kimliyi</h3>
                  <div className="form-group">
                    <label>Ad Soyad *</label>
                    <input type="text" name="owner_name" value={formData.owner_name} onChange={handleChange} placeholder="Əli Məmmədov" />
                  </div>
                  <div className="form-group">
                    <label>Vəzifəsi *</label>
                    <input type="text" name="owner_position" value={formData.owner_position} onChange={handleChange} placeholder="Direktor, Təsisçi" />
                  </div>
                  <div className="form-group">
                    <label>Telefon *</label>
                    <input type="tel" name="owner_phone" value={formData.owner_phone} onChange={handleChange} placeholder="+994501234567" />
                  </div>
                </div>
              )}

              {/* ── CHAIN: Step 3 — Email + Şifrə ───────────────────────── */}
              {isChain && currentStep === 3 && (
                <div className="form-step">
                  <h3>Giriş Məlumatları</h3>
                  <p style={{ fontSize: 13, color: '#888', marginBottom: 20 }}>
                    Müraciət təsdiqləndikdən sonra bu məlumatlarla daxil ola bilərsiniz.
                  </p>
                  <div className="form-group">
                    <label>Email *</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="admin@coffeemania.az" />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Şifrə * <small>(min. 6 simvol)</small></label>
                      <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="••••••••" />
                    </div>
                    <div className="form-group">
                      <label>Şifrəni Təsdiqlə *</label>
                      <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="••••••••" />
                    </div>
                  </div>
                  <div style={{
                    marginTop: 20, padding: '14px 16px', borderRadius: 10,
                    background: 'rgba(232,148,10,0.08)', border: '1px solid rgba(232,148,10,0.25)',
                    fontSize: 13, color: '#7a5000', lineHeight: 1.6,
                  }}>
                    ℹ️ Filial şəbəkəsi hesabı üçün ilkin ödəniş tələb olunmur. Hər filialı ayrıca əlavə edib aktivləşdirəcəksiniz.
                  </div>
                </div>
              )}

              {/* ── TERMS STEP ───────────────────────────────────────────── */}
              {isTermsStep && (
                <div className="form-step">
                  <h3>İstifadə Şərtləri və Gizlilik</h3>
                  <p style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>
                    Zəhmət olmasa şərtləri oxuyun və qəbul edin.
                  </p>
                  <div style={{
                    maxHeight: 340, overflowY: 'auto',
                    border: '1.5px solid #E2E8F0', borderRadius: 12,
                    padding: '18px 22px', background: '#FAFAFA', marginBottom: 20,
                  }}>
                    <TermsText />
                  </div>
                  <label style={{
                    display: 'flex', alignItems: 'flex-start', gap: 12,
                    cursor: 'pointer', padding: '14px 16px', borderRadius: 12,
                    border: `1.5px solid ${termsAccepted ? '#E8940A' : '#E2E8F0'}`,
                    background: termsAccepted ? '#FFF7E6' : '#fff',
                    transition: 'all 0.2s',
                  }}>
                    <input
                      type="checkbox"
                      checked={termsAccepted}
                      onChange={e => { setTermsAccepted(e.target.checked); setError(''); }}
                      style={{ width: 18, height: 18, marginTop: 2, accentColor: '#E8940A', flexShrink: 0, cursor: 'pointer' }}
                    />
                    <span style={{ fontSize: 14, color: '#374151', lineHeight: 1.6 }}>
                      <strong>İstifadə Şərtlərini</strong> və <strong>Gizlilik Siyasətini</strong> oxudum, başa düşdüm və qəbul edirəm. Abunəlik qiymətlərini rəqib platformalara açıqlamayacağımı təsdiqləyirəm.
                    </span>
                  </label>
                </div>
              )}

              {error && <div className="error-message">{error}</div>}

              <div className="form-navigation">
                <button type="button" className="back-button" onClick={handleBack}>← Geri</button>
                {!isTermsStep ? (
                  <button type="button" className="next-button" onClick={handleNext}>Növbəti →</button>
                ) : (
                  <button type="submit" className="submit-button" disabled={loading || !termsAccepted}>
                    {loading ? 'Göndərilir...' : '✅ Müraciəti Göndər'}
                  </button>
                )}
              </div>
            </form>

            <div className="register-footer">
              <p>Artıq hesabınız var? <a href="/login">Daxil olun</a></p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default RegisterPage;
